import axios from 'axios'
// import Login from '../views/Login'
// import router from '../router'
// import { Loading, Message } from 'element-ui'
// import selfConfig from '../../config/selfConfig'
// 超时时间
// axios.defaults.baseURL = selfConfig.API_SERVER
import { MessageBox } from 'element-ui'
axios.defaults.baseURL = 'http://139.224.56.72:8888'
// axios.defaults.baseURL = 'http://127.0.0.1:8888'
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.withCredentials = true
axios.defaults.transformRequest = function (request) {
  return JSON.stringify(request)
}

// let loadinginstace
// http请求拦截器
axios.interceptors.request.use(function (config) {
  //   loadinginstace = Loading.service({ fullscreen: true })
  if (config.method === 'post') {
    config.data = {
      ...config.data,
      head: {
        token: sessionStorage.logintoken,
        channel: '',
        clientId: '',
        userId: ''
      }
    }
  }
  return config
}, function (error) {
  //   loadinginstace.close()
  return Promise.reject(error)
})

// http响应拦截器
axios.interceptors.response.use(function (res) {
  // debugger
  if (res.data.code === 4) {
    console.log(res.data)
    console.log(res.data.code)
    // router.push("/ ");
    // router.push(
    //   {
    //      path: '/',
    //     query: { redirect: router.currentRoute.fullPath }
    //   })
    MessageBox.alert(res.data.msg, '错误', {
      confirmButtonText: '确定',
      type: 'error'
    })
    window.location.href = '/'
  }
  if (res.data.head && res.data.head.token) {
    sessionStorage.setItem('logintoken', res.data.head.token)
  }

  return res
}, function (error) {
  //   loadinginstace.close()

  return Promise.reject(error)
})



export default axios



// WEBPACK FOOTER //
// ./src/request/axios.js